<div class="new-customer-credit-page">
    <lsq-banner [titleText]="'New Customers'"></lsq-banner>
    <div class="container-fluid page-container">
        <ng-container *ngIf="!areResultsPresent()">
            <h2 *ngIf="!selectedCustomers.length" class="text-center">
                Search for your customer and add them.
            </h2>
            <h2 *ngIf="!!selectedCustomers.length" class="text-center">Add another customer.</h2>
            <div class="content-wrapper">
                <form [formGroup]="formGroup" class="search-customer-form">
                    <div class="form-wrapper row">
                        <lsq-autocomplete
                            class="col-12 col-sm-6"
                            name="name"
                            label="Name"
                            [floatLabel]="true"
                            placeholder="Enter Customer Name"
                            [establishment]="true"
                            [autoFocus]="true"
                            [group]="formGroup"
                            formControlName="name"
                            (selectResult)="populateResults($event, true)"
                        >
                        </lsq-autocomplete>

                        <lsq-input
                            class="col-6 col-sm-3"
                            label="City"
                            name="city"
                            [floatLabel]="true"
                            [group]="formGroup"
                            formControlName="city"
                        >
                        </lsq-input>
                        <lsq-select
                            class="col-6 col-sm-3"
                            label="State"
                            name="state"
                            [floatLabel]="true"
                            [group]="formGroup"
                            [options]="states"
                            formControlName="state"
                        >
                        </lsq-select>
                    </div>
                    <lsq-button
                        appearance="primary"
                        [disabled]="formGroup.invalid"
                        (buttonClick)="search()"
                    >
                        <lsq-icon
                            [type]="icons.FaMagnifyingGlassSolid"
                            [style.display]="'block'"
                        ></lsq-icon>
                    </lsq-button>
                </form>
                <lsq-circle-loader *ngIf="isSearching"></lsq-circle-loader>
                <div *ngIf="!isSearching && this.advancedSearchForm" class="results-section">
                    <h3 class="font-weight-bold text-center results-header">
                        If you still haven't found what you're looking for, add them manually.
                    </h3>
                    <div *ngIf="!!advancedSearchForm" class="advanced-search-card-wrapper">
                        <div class="advanced-search-card">
                            <div class="advanced-search-card-contents">
                                <div>
                                    <h3 class="bold">{{ advancedSearchForm.name }}</h3>
                                    <div>
                                        <lsq-address
                                            [singleLine]="true"
                                            [address]="{
                                                address1: advancedSearchForm.primaryAddress1,
                                                address2: advancedSearchForm.primaryAddress2,
                                                city: advancedSearchForm.primaryCity,
                                                state: advancedSearchForm.primaryState,
                                                postalCode: advancedSearchForm.primaryPostalCode,
                                                country: advancedSearchForm.primaryCountry
                                            }"
                                        >
                                        </lsq-address>
                                    </div>
                                </div>
                                <div *ngIf="!!advancedSearchForm.phone">
                                    <p class="font-weight-bold">Business Phone Number</p>
                                    <div>
                                        <p>{{ advancedSearchForm.phone | phone }}</p>
                                    </div>
                                </div>
                                <div *ngIf="!!advancedSearchForm.thirdPartyKey">
                                    <p class="font-weight-bold">Experian BIN</p>
                                    <div>
                                        <p>{{ advancedSearchForm.thirdPartyKey }}</p>
                                    </div>
                                </div>
                                <div *ngIf="!!advancedSearchForm.secondaryAddress1">
                                    <p class="font-weight-bold">Secondary Address</p>
                                    <lsq-address
                                        [singleLine]="true"
                                        [address]="{
                                            address1: advancedSearchForm.secondaryAddress1,
                                            address2: advancedSearchForm.secondaryAddress2,
                                            city: advancedSearchForm.secondaryCity,
                                            state: advancedSearchForm.secondaryState,
                                            postalCode: advancedSearchForm.secondaryPostalCode,
                                            country: advancedSearchForm.secondaryCountry
                                        }"
                                    >
                                    </lsq-address>
                                </div>
                            </div>
                            <lsq-icon
                                class="manual-icon-group-button"
                                [ngStyle]="{ right: '13rem', padding: '2rem' }"
                                [type]="icons.Edit"
                                [color]="color.Green"
                                (click)="showAdvancedSearchModal(advancedSearchForm)"
                            >
                            </lsq-icon>
                            <lsq-button
                                class="manual-icon-group-button"
                                [style.right]="'1.5rem'"
                                (buttonClick)="addResultManually()"
                            >
                                Add
                            </lsq-button>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isSearching && searchResults && showResults" class="results-section">
                    <h3 class="font-weight-bold text-center results-header">
                        Your search returned
                        {{
                            searchResults.length
                                | i18nPlural: { '=1': 'one result', other: '# results' }
                        }}.
                    </h3>
                    <lsq-icon
                        [type]="icons.Close"
                        [color]="color.Black"
                        class="close-button"
                        (click)="hideResults()"
                    ></lsq-icon>
                    <div>
                        <search-customer-card
                            *ngFor="let result of searchResults"
                            [name]="result.name"
                            [address]="result.address"
                        >
                            <lsq-icon-popover
                                *ngIf="isResultAlreadySelected(result)"
                                [style.margin-right.rem]="2"
                                text="This customer has already been selected"
                            >
                            </lsq-icon-popover>
                            <lsq-button
                                [disabled]="isResultAlreadySelected(result)"
                                (buttonClick)="
                                    addResult({
                                        name: result.name,
                                        primaryAddress1: result.address.address1,
                                        primaryAddress2: result.address.address2,
                                        primaryCity: result.address.city,
                                        primaryState: result.address.state,
                                        primaryPostalCode: result.address.postalCode,
                                        primaryCountry: result.address.country,
                                        thirdPartyKey: result.thirdPartyKey,
                                        phone: result.phone
                                    })
                                "
                            >
                                Add
                            </lsq-button>
                        </search-customer-card>
                    </div>
                    <div class="add-manually-section text-center">
                        <h4 *ngIf="!this.advancedSearchForm" class="font-weight-normal">
                            Try
                            <a (click)="showAdvancedSearchModal()" class="font-weight-bold"
                                >Advanced Search</a
                            >
                            if you didn't find what you're looking for.
                        </h4>
                    </div>
                </div>
                <div
                    *ngIf="!isSearching && !showResults && selectedCustomers.length"
                    class="selection-section"
                >
                    <search-customer-card
                        *ngFor="let selectedCustomer of selectedCustomers; let i = index"
                        [name]="selectedCustomer.companyDetails.name"
                        [address]="{
                            address1: selectedCustomer.companyDetails.primaryAddress1,
                            address2: selectedCustomer.companyDetails.primaryAddress2,
                            city: selectedCustomer.companyDetails.primaryCity,
                            state: selectedCustomer.companyDetails.primaryState,
                            postalCode: selectedCustomer.companyDetails.primaryPostalCode,
                            country: selectedCustomer.companyDetails.primaryCountry
                        }"
                    >
                        <form class="amount-form" [formGroup]="selectedCustomer.form">
                            <lsq-currency-input
                                [name]="'amount' + i"
                                [group]="selectedCustomer.form"
                                formControlName="amount"
                                label="How much are you owed on average?"
                            >
                            </lsq-currency-input>
                        </form>
                        <lsq-button
                            ariaLabel="Remove"
                            appearance="transparent"
                            class="remove-btn"
                            (buttonClick)="removeSelection(i)"
                        >
                            <lsq-icon
                                class="delete-button"
                                [type]="icons.Trash"
                                [color]="color.GrayDark"
                            ></lsq-icon>
                        </lsq-button>
                    </search-customer-card>
                </div>
                <div *ngIf="showResults || selectedCustomers.length" class="text-right cta-button">
                    <lsq-button
                        [submitting]="addDebtorsIsSubmitting"
                        [disabled]="isDisabled()"
                        (buttonClick)="requestCredit()"
                    >
                        Continue
                    </lsq-button>
                </div>
            </div>
        </ng-container>
        <div *ngIf="areResultsPresent()" class="content-wrapper confirmation-page">
            <div class="text-center">
                <lsq-icon [color]="color.Green" [type]="icons.CheckmarkCircle"></lsq-icon>
            </div>
            <h2 *ngIf="!isExistingCustomer" class="text-center completed-title">
                You added
                {{
                    selectedCustomers.length
                        | i18nPlural: { '=1': 'a new customer', other: 'new customers' }
                }}.
            </h2>
            <h2 *ngIf="isExistingCustomer" class="text-center completed-title">
                Your
                {{
                    selectedCustomers.length
                        | i18nPlural: { '=1': "customer's", other: "customers'" }
                }}
                credit has been processed.
            </h2>
            <div>
                <div *ngIf="approvedCustomers.length" class="status-section approved">
                    <h6 class="section-title">Approved</h6>
                    <credit-status-card
                        *ngFor="let customer of approvedCustomers"
                        [customer]="customer"
                    ></credit-status-card>
                </div>
                <div *ngIf="declinedCustomers.length" class="status-section declined">
                    <h6 class="section-title">Declined</h6>
                    <lsq-icon-popover
                        text="We are unable to extend a credit limit to your customer at this time because of bad payment history or limited credit information."
                    ></lsq-icon-popover>
                    <credit-status-card
                        *ngFor="let customer of declinedCustomers"
                        [customer]="customer"
                    ></credit-status-card>
                </div>
                <div *ngIf="pendingCustomers.length" class="status-section pending">
                    <h6 class="section-title">Pending</h6>
                    <lsq-icon-popover
                        text="LSQ's credit department is reviewing your credit request."
                    ></lsq-icon-popover>
                    <credit-status-card
                        *ngFor="let customer of pendingCustomers"
                        [customer]="customer"
                    ></credit-status-card>
                </div>
            </div>
            <div class="footer-buttons">
                <lsq-button appearance="transparent" (buttonClick)="resetPage()">
                    Add More Customers
                </lsq-button>
                <lsq-button [routerLink]="creditRequestHistoryRouterLink">
                    View Credit History
                </lsq-button>
            </div>
        </div>
    </div>
</div>

<ng-template #noResultsBody>
    <p [style.margin-bottom]="'1rem'">
        Please make sure customer name is spelled correctly.
    </p>
</ng-template>
